import { mapState, mapActions, mapMutations } from 'vuex'
import validEmail from '@/module/util/valid-email.js'

import Inputs from './input/components'
import Displays from './display/components'
import Icons from './icons'
import SubmitButton from './button/SubmitButton'

const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
const DEVICE_ID_LENGTH = 16

function generateDeviceId() {
    var id = []
    for (var i = 0 ; i < DEVICE_ID_LENGTH ; i++)
        id.push(ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length)))
    return id.join('')
}

export default {

    props: {
        query: {
            type: Object
        }
    },

    data() {
        // Generate a unique device ID and store in session storage
        var device
        if (window.sessionStorage)
            device = sessionStorage.getItem('device')
        if (! device) {
            device = generateDeviceId()
            if (window.sessionStorage)
                window.sessionStorage.setItem('device', device)
        }

        return {
            pageStep: 'default',

            // Full name input
            name: '',
            nameError: null,
            loginPop: false,

            // Email input
            email: '',
            emailError: null,

            // Password
            password: '',
            passwordError: null,

            // Confirm Password
            confirmPassword: '',
            confirmPasswordError: null,

            // Reset Code
            code: '',
            codeError: null,

            mfaCode: '',

            mfaError: null,

            // Reset token
            resetToken: '',

            device,
            platform: 'Web',

            loginLoading: false,
            mfaLoading: false,

            // UI flag for transitioning to the next view
            transition: false,

            autoLogoutSet: false,
            newPassword: '',
            setPasswordLoading: false,
            setPasswordError: '',

            maskedEmail: null,
            maskedPhone: null,
            isEmailMfa: false

        }
    },
    mounted() {
        if (this.query) {
            this.setQuery(this.query)

            if (this.query.token) {
                this.postVerifyToken({
                    token: this.query.token
                })
                .then((result) => {
    				if(result.payload && !result.payload.cp)
    				    this.success()
                })
                .catch((err) => {
                })
            }
        }
        if(this.autoLogout) {
            this.autoLogoutSet = true
            this.setAutoLogout(false)
        }

    },
    methods: {
        ...mapActions('auth', {
            postLogin: 'login',
            postInitiateLogin: 'initiateLogin',
            postValidateCode: 'validateCode',
            postVerifyInvite: 'verifyInvite',
            postInvite: 'invite',
            postReset: 'reset',
            postVerifyReset: 'verifyReset',
            postVerifyToken: 'verifyToken',
            postResetPassword: 'resetPassword',
            setQuery: 'setQuery',
            submitMfa: 'submitMfa',
            changePassword: 'changePassword',
            // postJoin: 'join',
            // postInitiateJoin: 'initiateJoin'
        }),
        ...mapMutations('auth', ['setAutoLogout']),

        /**
         * @func login
         * @desc Attempts to login with the given email address and password.
         */
        login() {
            if (this.authenticating) return
            this.emailError = ''

            if(!validEmail(this.email)) {
                this.emailError = "Invalid Email"
                return
            }

            this.loginLoading = true
            return this.postLogin({
                email: this.email,
                password: this.password,
                device: this.device,
                platform: this.platform,
                mfa: (this.choiceMfa === 'email') ? 'email' : 'phone'
            })
            .then((response) => {
                if(response.mfa) {
                    this.pageStep = 'mfa'
                    this.maskedEmail = response.mfa_email
                    this.maskedPhone = response.mfa_phone
                    this.isEmailMfa = response.is_email_mfa
                }
                else if(response.changePassword)
                    this.pageStep = 'changePassword'
                else
                    this.success()
            })
            .finally(() => this.loginLoading = false)
            .catch((error) => {
                if(error.code === 'InvalidUser')
                    this.emailError = 'Sorry, we don\'t seem to have a provider account associated with this email'
                else if(error.code === 'ApiError')
                    this.errorReload()
                else
                    this.passwordError = error.message || 'Incorrect password'
                throw error
            })
        },

        sendMfa() {
            if(this.mfaCode.length < 6)
                return
            this.mfaLoading = true
            this.mfaError = null
            this.submitMfa(this.mfaCode)
                .then((response) =>{
                    console.log(response)
                    if(response.changePassword)
                        this.pageStep = 'changePassword'
                    else
                        this.success()
                })
                .catch((error) => {
                    console.log('Error',error)
                    this.mfaCode = ''
                    if(error.code === 'InvalidMFA')
                        this.mfaError = "The code you entered does not match the secure code we sent. Please check your message and try again."
                    else
                        this.mfaError = error.code
                })
                .finally(() => this.mfaLoading = false)
        },

        setPassword() {
            if(this.newPassword !== this.confirmPassword) {
                this.setPasswordError = 'Both Passwords do not match'
                return
            }
            this.setPasswordLoading = true
            this.changePassword({
                password: this.newPassword
            })
            .then((response) => this.success())
            .catch((error) => this.setPasswordError = error)
            .finally((_) => this.setPasswordLoading = false)
        },
        

        /**
         * @func initiateLogin
         * @desc Initiates a login request.
         */
        initiateLogin() {
            if (this.authenticating) return

            // Reset the error message
            this.emailError = null

            // Dispatch the login initiation action
            return this.postInitiateLogin({
                email: this.email
            })
            // On a successful response, redirect if the user is a light user
            .then(() => {
                if (this.light)
                    this.$router.push('/upgrade')
            })
            // Display the error message
            .catch((error) => {
                this.emailError = error.message || 'Invalid email'
                throw error
            })
        },
        /**
         * Shows error on password input and reloads after 3 seconds
         */
        errorReload() {
            let secondsLeft = 4
            this.passwordError = `Error connecting to Server, Retrying in ${secondsLeft}`
            window.setTimeout(() => location.reload(), secondsLeft * 1000)
            window.setInterval(() => {
                secondsLeft -= 1
                this.passwordError = `Error connecting to Server, Retrying in ${secondsLeft}`
            }, 1000)
        },

        reset(email) {
            if (this.authenticating) return
            // TODO
            return this.postReset({
                email: email ? email : this.email
            })
        },

        resetPassword(params) {
            if (this.authenticating) return

            return this.postResetPassword(params)
        },

        verifyReset(params) {
            if (this.authenticating) return

            return this.postVerifyReset(params)
        },

        invite() {
            return this.postInvite({
                auth: this.authenticatedId,
                invite_token: this.authenticatedInviteToken,
                password: this.password,
                device: this.device,
                platform: this.platform
            })
            .then(() => {
                this.success()
            })
            .catch((error) => {
                this.passwordError = error.message || 'Invalid password'
                throw error
            })
        },

        verifyInvite(query) {
            return this.postVerifyInvite(query)
        },

        nextForm(next) {
            this.$emit('next', next)
        },

        success() {
            this.transition = true
            this.$emit('success')
            setTimeout(() => {
                this.$router.push(this.redirect || '/')
            }, 300)
        },
        /**
         * Change pageStep to get mfa code somewhere else
         */
        getMfaElse() {
            this.pageStep = 'mfaChoice'
            this.choiceMfa = this.isEmailMfa ? 'phone' : 'email'
        },
        /**
         * Listen to keys and do some shortcut stuff
         */
        keyListener(e) {
            if(this.pageStep === 'mfaChoice' && e.keyCode === 13)
                this.login()
        }
    },

    computed: {
        ...mapState([
			'redirect'
		]),
		...mapState('auth', [
			'authenticating',
			'authenticated',
            'light',
            'autoLogout'
		]),
        // If the user is already authenticated
        ...mapState('auth', {
            authenticatedId: 'id',
            authenticatedName: 'name',
            authenticatedEmail: 'email',
            authenticatedCode: 'code',
            authenticatedInviteToken: 'inviteToken',
            authenticatedCodeProvider: 'codeProvider',
            authenticatedResetToken: 'resetToken',
            failedValidation: 'failedValidation'
        }),
        setPasswordDisabled() {
            return this.newPassword.length < 8
        }
    },

    components: {
        ...Inputs,
        ...Displays,
        ...Icons,
        SubmitButton
    }
}
